<template>
	<div id="app" syno-id="loginform-page">
	<v-app id="inspire">
		<v-content>
			<v-container
				fluid
				fill-height
			>
				<v-layout
					align-center
					justify-center
				>
					<v-flex
						xs12
						sm8
						md4
					>
						<v-card class="elevation-12" syno-id="loginform-card">
							<v-toolbar
								color="primary"
								dark
								flat
							>
								<v-spacer></v-spacer>
								<v-toolbar-title syno-id="loginform-title">Please Login</v-toolbar-title>
								<v-spacer></v-spacer>
							</v-toolbar>
							<v-card-text>
								<v-form syno-id="loginform-form">
									<v-text-field
										v-model="userid"
										label="userid"
										name="userid"
										syno-id="loginform-userid-input"
										type="text"
									></v-text-field>

									<v-text-field
										v-model="password"
										id="password"
										label="Password"
										name="password"
										syno-id="loginform-password-input"
										type="password"
									></v-text-field>
								</v-form>
							</v-card-text>
							<v-card-actions>
								<v-spacer></v-spacer>
								<v-btn v-on:click.native="submit" color="primary" syno-id="loginform-login-btn">Login</v-btn>
							</v-card-actions>
						</v-card>
					</v-flex>
				</v-layout>
			</v-container>
		</v-content>
	</v-app>
</div>
</template>

<script>
export default {
	name: 'Loginform',
	data() {
		return {
			userid: null,
			password: null,
		}
	},
	methods: {
		submit: function() {
			/* eslint-disable */
			var urlParams = new URLSearchParams(window.location.search);
			console.log("userid: ", this.userid)
			console.log("password: ", this.password)
			self=this;
			this.$conf.HYDRA_PROXY_HTTP.post('/loginsubmit?'+urlParams.toString(), {
  user: this.userid, password: this.password}, null)
			.then(response => {
				if (302 == response.status) {
					window.location = response.request.res.responseUrl;
				} else {
				console.log("error: response:",response)
				}
			})
			.catch((error)=>{
				console.log("logout error", error)
				console.log("error code = "+ error.response.status + ",msg = " + error.response.data.message)
			});
		}
	}
}
</script>
